import { Breadcrumb, Button, Card, Col, Dropdown, Flex, Layout, Row, Select, Space, Table, Tabs } from "antd";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";

import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";
import FormItem from "antd/es/form/FormItem";
import { ReactComponent as DownloadICon } from "../../../assets/icon/downloadIcon.svg";
import WorkingTimeModal from "./reportModal/WorkingTimeModal";
import { DownloadOutlined, MoreOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import WorkingTimeLeaveModal from "./reportModal/WorkingTimeLeaveModal";

const WorkingAbsenceComponent = ({
    showReport,
    employeeOptions = [],
    reportTableWoringTime = [],
    initialValues,
    onChange = () => { },
    pagination = {},
    pagination2 = {},
    departmentOptions = [],
    positionOptions = [],
    workInLocationList = [],
    handleSearch = () => { },
    exportWorkingTimeGroupReport = () => { },
    exportWorkingTimeGroupReportAll = () => { },
    exportWorkingTimeGroupReportDetail = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { },
    isDownloading = false,
    ddlDate = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const currentYear = new Date().getFullYear().toString();
    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/BBBB HH:mm`);
    }


    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 100,
            render: (_, record, idx) => {
                return <span style={{ color: "#667085" }}>{(pagination.pageNo - 1) * pagination.size + idx + 1}</span>;
            },

        },
        {
            title: <div className="text-table">{t('employee.label.employee_id')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "left",
            width: 150,
            // render: (_, record) => {
            //     return employeeNo;
            // },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeInfo",
            key: "employeeInfo",
            align: "center",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record.employeeNameEn;
                }
                return record.employeeName;
            },

        },
        {
            title: <div className="text-table">{t('position.header')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.positionEn ? record?.positionEn : "-";
                }
                return record?.position ? record?.position : "";
            },

        },
        {
            title: <div className="text-table">{t('employee.label.department')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.departmentEn ? record?.departmentEn : "-";
                }
                return record?.department ? record?.department : "";
            },

        },
        {
            title: <div className="text-table">{t('employment.date')}</div>,
            dataIndex: "employmentDate",
            key: "employmentDate",
            align: "left",
            width: 250,
            render: (_, record) => {

                return dayjs(_).format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/BBBB`)
            },

        },
        {
            title: <div className="text-table">{t('home.absence')}</div>,

            align: "center",
            width: 150,
            children: [
                {
                    title: <div className="text-table">{t('times')}</div>,
                    dataIndex: "countDayAbsence",
                    key: "countDayAbsence",
                    align: "center",
                    width: 150,
                    // render: (_, record) => {
                    //     return record?.checkInDatetime ? formatDate(record?.checkInDatetime) : "-";
                    // },
                }
            ],
        },

        {
            title: <div className="text-table">{t('lateTime')}</div>,

            align: "center",
            width: 150,
            children: [
                {
                    title: <div className="text-table">{t('times')}</div>,
                    dataIndex: "countDayLate",
                    key: "countDayLate",
                    align: "center",
                    width: 75,
                    // render: (_, record) => {
                    //     return record?.checkInDatetime ? formatDate(record?.checkInDatetime) : "-";
                    // },
                },
                {
                    title: <div className="text-table">{t('unit.hour')}</div>,
                    dataIndex: "countMinuteLate",
                    key: "countMinuteLate",
                    align: "center",
                    width: 75,
                    render: (_, record) => {
                        let minutes = _;
                        const hours = Math.floor(minutes / 60);
                        const mins = minutes % 60;
                        return `${hours}.${mins.toString().padStart(2, '0')}`;
                        // return _ ? get2DecimalPointsWithCommas(Number(hours + "." + remainMinutes)) : 0;
                    },
                }
            ],
        },
        {
            title: <div className="text-table">{t('leave-work')}</div>,
            align: "center",
            width: 150,
            children: [
                {
                    title: <div className="text-table">{t('times')}</div>,
                    dataIndex: "countDayLeave",
                    key: "countDayLeave",
                    align: "center",
                    width: 75,
                    // render: (_, record) => {
                    //     return record?.checkInDatetime ? formatDate(record?.checkInDatetime) : "-";
                    // },
                },
                {
                    title: <div className="text-table">{t('unit.hour')}</div>,
                    dataIndex: "countMinuteLeave",
                    key: "countMinuteLeave",
                    align: "center",
                    width: 75,
                    render: (_, record) => {
                        let minutes = _;
                        const hours = Math.floor(minutes / 60);
                        const mins = minutes % 60;
                        return `${hours}.${mins.toString().padStart(2, '0')}`;
                        // return _ ? get2DecimalPointsWithCommas(Number(hours + "." + remainMinutes)) : 0;
                    },
                }
            ],
        },

    ];
    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);
    return (
        <MainLayout>
            <WorkingTimeLeaveModal
                name={t("Absence_report.header")}
                name2={t("Absence_report.header2")}
                isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}
                exportWorkingTimeGroupReport={exportWorkingTimeGroupReportAll}
                exportWorkingTimeGroupReport2={exportWorkingTimeGroupReportDetail}
                isDownloading={isDownloading} />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t('report.header'), href: "" },
                        { title: t('working_time_group.header'), href: "" },
                        { title: t('Absence_report.header') }
                    ]} />
                    <h2>{t('Absence_report.header')}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        // workingTimeDate
                        // workingTimeDatePicker
                        if ((prev['workingTimeDate'] !== curv['workingTimeDate']) && curv['workingTimeDate'] != null) {
                            curv['workingTimeDatePicker'] = null
                        }
                        if ((prev['workingTimeDatePicker'] !== curv['workingTimeDatePicker']) && curv['workingTimeDatePicker'] != null) {
                            curv['workingTimeDate'] = null
                        }
                        return ((prev['workingTimeDate'] !== curv['workingTimeDate']) && curv['workingTimeDate'] != null)
                            || ((prev['workingTimeDatePicker'] !== curv['workingTimeDatePicker']) && curv['workingTimeDatePicker'] != null)
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t('warning_letter.label.employee')}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        multiple={true}
                                                        // mode="multiple"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        tree={true}
                                                    // onChange={handleChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        multiple={true}
                                                        // mode="multiple"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        // onChange={handleChange}
                                                        size="large"
                                                        tree={true}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        required={getFieldValue("workingTimeDatePicker") == null}
                                                        name="workingTimeDate"
                                                        type="range"
                                                        options={ddlDate()}
                                                        label={t('my_request.label.totalDuration')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('my_request.label.totalDuration')}
                                                        size="large"
                                                        sortBy="value"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        required={getFieldValue("workingTimeDate") == null}
                                                        name="workingTimeDatePicker"
                                                        type="range"
                                                        options={ddlDate()}
                                                        label={t('start-date-to-end-date')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-date-to-end-date')}
                                                        size="large"
                                                        sortBy="value"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>

                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>
                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadICon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <TableAntd
                                                    onChange={onChange}
                                                    pagination={pagination}
                                                    columns={columns}
                                                    dataSource={reportTableWoringTime}
                                                    rowKey={(record) => record.id}
                                                    scroll={{ x: scrollX }}
                                                    tableLayout="fixed"
                                                />
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    );
}

export default WorkingAbsenceComponent;
